import { Fragment, useState, useEffect, useRef } from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from 'styled-components';
import Welcome from "./components/Welcome";
import About from './components/About';
import Portfolio from "./components/Portfolio";
import Popup from "./components/Popup";
import { GlobalStyles } from "./styles/GlobalStyles.style";
import { lightMode, darkMode } from './styles/Theme';
import Contact from "./components/Contact";
import NightModeControl from "./components/NightModeControl";

function App() {

  let initialState = (localStorage.getItem('theme')) ? 
    localStorage.getItem('theme') :
    'light';

  const [theme, setTheme] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState(false);
  const [popupDetails, setPopupDetails] = useState(false);
  const [portfolioIndex, setPortfolioIndex] = useState(0);

  /******************************
   * Stop body scroll on popup***
   * ****************************
   ******************************/

  useEffect(() => {
    localStorage.setItem('theme', theme);
    if(popup) {
      document.querySelector('body').classList.add('stop-scroll');
    } else {
      document.querySelector('body').classList.remove('stop-scroll');
    }
  }, [popup, theme]);

  const handleThemeToggle = () => {
    theme === 'light' ? setTheme('dark') : setTheme('light');
  }

    /*****************************************
     * ******portfolio popup handlers*********
     *****************************************/

    const handlePopup = (e) => {
      if(e.target.closest('.portfolio__item--inner')) {
        const portfolioItem = e.target.closest('.portfolio__item--inner').parentElement;
        
        let itemIndex = [...portfolioItem.parentElement.children].indexOf(portfolioItem);
        setLoading(true);
        setPortfolioIndex(itemIndex);

        togglePopup();
      }
    }

    const handlePopupClose = () => {
      togglePopup();
      if(popupDetails) {
        togglePopupDetails();
      }
    }

    const togglePopup = () => setPopup(!popup);
    const stopLoading = () => setLoading(false);

    const togglePopupDetails = () => setPopupDetails(!popupDetails);


    /***************************************
     * *********Focus Input from anywhere***
     * *************************************
     ***************************************/

    const inputRef = useRef();

    const handleInputFocus = () => inputRef.current.focus();
  
  return (
    <Fragment>
      <BrowserRouter>
        <ThemeProvider theme={theme === 'dark' ? darkMode : lightMode}>
          <GlobalStyles/>
          <Welcome onInputFocus={handleInputFocus}/>
          <About 
            onInputFocus={handleInputFocus}
            onThemeToggle={handleThemeToggle}
          />
          <Portfolio
            index={portfolioIndex}
            onPopup={handlePopup}
          />
          <Contact 
            ref={inputRef}
            placeholder="Name"
          />
          <Popup 
            isOpen={popup}
            detailsIsOpen={popupDetails}
            loading={loading}
            onImgLoad={stopLoading}
            index={portfolioIndex}
            onClose={handlePopupClose}
            onDetailsToggle={togglePopupDetails}
          />
          <NightModeControl 
            onThemeToggle={handleThemeToggle}
          />
        </ThemeProvider>
      </BrowserRouter>
    </Fragment>
  );
}

export default App;
